/* ------ FADE IN IMAGES ------ */

function fadeInRageImages(){
  document.querySelectorAll('img.rage-img-fadein').forEach(function(img){
    function fadeIn() {
      img.classList.remove('rage-img-loading');
    }
    // In case the image is already loaded from cache
    if (img.complete && img.naturalWidth !== 0) {
      fadeIn();
    } else {
      img.addEventListener('load', fadeIn, { once: true });
    }
  });
}

/* ------ RAGE HEADER ------ */

function fadeInRageHeader() {
  var el = document.querySelector('.rage-header-container');
  if (el && el.classList.contains('rage-header-fade-init')) {
    el.classList.remove('rage-header-fade-init');
    el.classList.add('rage-header-fade-in');
    el.addEventListener('transitionend', function handler(e) {
      if (e.propertyName === 'opacity') {
        el.classList.remove('rage-header-fade-in');
        el.removeEventListener('transitionend', handler);
      }
    });
  }
}

function initRageHeader() {
  const parentHeader = document.querySelector("header.rage-header");

  // Check if the header exists
  if (!parentHeader) {
    console.error("Could not find the header element.");
    return;
  }

  const checkScrollPosition = () => {
    const currentScrollY = window.scrollY;

    // Add or remove the "snapped" class based on scroll position
    if (currentScrollY > 0) {
      parentHeader.classList.add("snapped");
    } else {
      parentHeader.classList.remove("snapped");
    }
  };

  // Run the function on load to account for already-scrolled pages
  checkScrollPosition();

  // Attach the scroll event listener
  window.addEventListener("scroll", checkScrollPosition);
}

/* ------ MAIN NAVIGATION ------ */

const toggleMenu = document.querySelector(".rageburger");
const pageBody = document.body;
const menu = document.querySelector(".rage-mobile-menu");
const pageHtml = document.documentElement;

function initToggleMenu() {
  
  if (typeof toggleMenu != "undefined" && toggleMenu != null) {
    
    toggleMenu.addEventListener("click", function() {
      const open = JSON.parse(toggleMenu.getAttribute("aria-expanded"));
      toggleMenu.setAttribute("aria-expanded", !open);
      menu.hidden = !menu.hidden;
      pageBody.classList.toggle("navigation-active-mobile");
      pageBody.classList.toggle("lock-scroll");
      toggleMenu.classList.toggle("is-active");
      pageHtml.toggleAttribute('scroll-lock');
  
      if (!menu.hidden) {
        menu.querySelector("a").focus();
      }
    });
  }
  
}


/* ------ INITIALISE ON DOC READY ------ */

let ready = (callback) => {
  if (document.readyState != "loading") callback();
  else document.addEventListener("DOMContentLoaded", callback);
}

ready(() => {
  fadeInRageImages();
  fadeInRageHeader();
  initRageHeader();
  initToggleMenu();
});

// Mutate: re-run when header is replaced
const observer = new MutationObserver(function(mutationsList) {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      // Check for re-added .rage-header-container
      const el = document.querySelector('.rage-header-container');
      if (el && el.classList.contains('rage-header-fade-init')) {
        fadeInRageHeader();
      }
    }
  }
});

// Watch the document body, or (better) the parent node of your header
observer.observe(document.body, { childList: true, subtree: true });